import React from "react";
import groupImg from "../../../assets/images/rockinyangon/group.jpg";
const About = () => {
  return (
    <div className="  grid md:grid-cols-2 gap-10 bg-[#1D1D1D]  pb-20 px-5 ">
      <div className="grid-cols-1 flex justify-center items-center">
        <div className="flex gap-5 md:pl-10">
          <div className="md:w-[400px] lg:w-[550px]">
            <img src={groupImg} className=" w-full" alt="" />
          </div>
        </div>
      </div>
      <div className="grid-cols-1 flex flex-col  justify-center gap-4 lg:pl-20 md:pl-10 ">
        <div className="w-24 h-[2px] bg-[#E83B37]" />

        <h1 className="capitalize text-[#E83B37] lg:text-[42px] text-3xl titlefont ">
          Rock in Yangon
        </h1>
        <p className="text-white text-base lg:text-xl tracking-wider leading-10">
          ဖျော်ဖြေပွဲကြီးကို အောက်တိုဘာ ၂၁ ရက်နေ့
          <span className="text-[#e83b37] font-medium titlefont px-2">
            Yangon Hexagon Complex
          </span>
          မှာကျင်းပပြုလုပ်သွားမှာဖြစ်ပြီး အဆိုတော်
          <span className="text-[#e83b37] font-bold textfont px-2 ">
            နောနော် ,
          </span>
          <span className="text-[#e83b37] font-medium titlefont px-1 ">
            G Latt ,
          </span>
          <span
            className="text-[#e83b37] font-bold titlefont px-1
          "
          >
            ဝေလ
          </span>
          တို့နဲ့အတူ
          <span className="text-[#e83b37] font-medium titlefont px-1">
            Wanted ,
          </span>
          <span className="text-[#e83b37] font-medium titlefont px-1">
            Eternal Gosh
          </span>
          တို့လည်း ပါ၀င်ဖျော်ဖြေသွားမှာဖြစ်ပါတယ်
        </p>
        <p></p>
      </div>
    </div>
  );
};

export default About;
